import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo-nova.png';
import perfil from '../assets/images/user-blue.png';
import carrinho from '../assets/images/cart-blue.png';

const Header = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Estado para o menu responsivo
  const totalItems = cartItems.reduce((total, item) => total + item.quantidade, 0);
  const navigate = useNavigate();

  const isAuthenticated = !!localStorage.getItem('token');
  const isStaff = localStorage.getItem('is_staff') === 'true';
  const username = localStorage.getItem('username') || 'Usuário';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('is_staff');
    navigate('/login');
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const fetchSearchResults = async (term) => {
    if (term.trim()) {
      try {
        const response = await fetch(`https://crmesquita.com.br/api/produtos/?search=${term}`);
        const data = await response.json();

        const terms = term.toLowerCase().split(' ');
        const filteredResults = data.filter((product) =>
          terms.every((t) =>
            product.nome.toLowerCase().includes(t) || product.descricao?.toLowerCase().includes(t)
          )
        );

        setSearchResults(filteredResults);
      } catch (error) {
        console.error('Erro ao buscar produtos:', error);
      }
    } else {
      setSearchResults([]);
    }
  };

  const handleSearch = debounce((term) => {
    fetchSearchResults(term);
  }, 300);

  const handleInputChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    handleSearch(term);
  };

  const handleResultClick = (id) => {
    navigate(`/produto/${id}`);
    setSearchResults([]);
    setSearchTerm('');
  };

  const handleRemoveFromCart = (id) => {
    const updatedCart = cartItems.filter((item) => item.id !== id);
    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  const handleBuy = async () => {
    try {
      const cart = JSON.parse(localStorage.getItem('cart')) || [];
      if (cart.length === 0) {
        alert('O carrinho está vazio!');
        return;
      }

      const token = localStorage.getItem('token');
      if (!token) {
        alert('Você precisa estar logado para realizar a compra.');
        return;
      }

      const emailResponse = await fetch('https://crmesquita.com.br/api/get-user-email/', {
        method: 'GET',
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      if (!emailResponse.ok) {
        alert('Erro ao obter o e-mail do usuário. Tente novamente.');
        return;
      }

      const emailData = await emailResponse.json();
      const userEmail = emailData.email || 'Não informado';

      let mensagem = `Olá, gostaria de comprar os seguintes produtos:\n\n`;
      cart.forEach((item) => {
        mensagem += `- ${item.nome} (Quantidade: ${item.quantidade})\n`;
      });
      mensagem += `\nE-mail do cliente: ${userEmail}`;

      const whatsappNumber = '5551983422322';
      const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(mensagem)}`;

      window.open(whatsappLink, '_blank');
    } catch (error) {
      console.error('Erro ao processar a compra:', error);
      alert('Erro ao processar a compra. Tente novamente.');
    }
  };
  
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        setIsScrollingDown(true);
      } else {
        setIsScrollingDown(false);
      }

      setLastScrollY(currentScrollY);
    };

    const loadCartItems = () => {
      const cart = JSON.parse(localStorage.getItem('cart')) || [];
      setCartItems(cart);
    };

    window.addEventListener('scroll', handleScroll);

    loadCartItems();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);


  return (
    <header className={`bg-white shadow p-4 flex flex-col items-center ${isScrollingDown ? 'hidden' : ''}`}>
        <div className="sub-header flex justify-between items-center w-full max-w-6xl">
        <img src={logo} alt="Logo CR Mesquita" className="h-12 logo_cr" />
        <button
          className="menu-button md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)} // Alterna o estado do menu
        >
          ☰
        </button>
        <nav className={`space-y-4 ${isMenuOpen ? 'block' : 'hidden'} md:flex md:space-x-4`}>
          <Link to="/" className="text-gray-700 hover:text-red-600">Home</Link>
          {isAuthenticated && isStaff && (
            <Link to="/funcionarios" className="text-gray-700 hover:text-red-600">Funcionários</Link>
          )}
        
          <Link to="/pesquisar-produtos" className="text-gray-700 hover:text-red-600">Produtos</Link>
        </nav>
      </div>
   
      <div className="search-and-login relative w-full max-w-6xl">
      
        {isAuthenticated && (
        <button onClick={() => setIsCartOpen(!isCartOpen)} className="cart-button">
          <img src={carrinho} alt="Carrinho de compras" className="h-8 w-8" />
          {totalItems > 0 && (
            <span className="number-of-items absolute top-0 right-0 bg-red-600 text-white text-xs rounded-full px-2">
              {totalItems}
            </span>
          )}
        </button>
      )}


      {isAuthenticated && isCartOpen && (
        <div className="cart-dropdown">
          <ul className="cart-items">
            {cartItems.length > 0 ? (
              cartItems.map((item) => (
                <li key={item.id} className="cart-item">
                  <img src={item.imagem} alt={item.nome} className="cart-image" />
                  <div className="item-details">
                    <p className="item-name">{item.nome}</p>
                    <p className="item-price">Qtd: {item.quantidade}</p>
                  </div>
                  <button
                    onClick={() => handleRemoveFromCart(item.id)}
                    className="remove-button"
                  >
                    Remover
                  </button>
                </li>
              ))
            ) : (
              <li className="cart-empty-message">Carrinho vazio</li>
            )}
          </ul>
          {cartItems.length > 0 && (
            <div className="cart-footer">
              <button className="checkout-button" onClick={() => handleBuy()}>
                Comprar
              </button>
            </div>
          )}
        </div>
      )}

        <form className="search-form flex items-center space-x-2">
          <input
            type="text"
            placeholder="  Buscar produtos"
            value={searchTerm}
            onChange={handleInputChange}
            className="input-search border border-gray-300 rounded px-4 py-2 w-full"
          />
        </form>

        {isAuthenticated ? (
          <div className="cart-and-user relative flex items-center space-x-4">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center"
            >
              <img src={perfil} alt="Usuário" className="user-image h-8 w-8 rounded-full cursor-pointer" />
            </button>
            {isDropdownOpen && (
              <div className="dropdown-menu absolute bg-white border border-gray-300 rounded shadow-lg z-50">
                <div className="px-4 py-2 text-gray-700 font-bold border-b border-gray-200">
                  {username}
                </div>
                <ul className="py-2">
                  <li
                    onClick={() => navigate('/meus-pedidos')}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700"
                  >
                    Meus Pedidos
                  </li>
                  <li
                    onClick={handleLogout}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-700"
                  >
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        ) : (
          <Link to="/login" className="button-login text-gray-700 hover:text-red-600">
            Login
          </Link>
        )}

        {searchResults.length > 0 && (
          <div className="search-results-container absolute bg-white border border-gray-300 rounded shadow-lg mt-2 w-full z-50">
            <ul className="search-results-list overflow-y-auto max-h-60">
              {searchResults.map((product) => (
                <li
                  key={product.id}
                  className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleResultClick(product.id)}
                >
                  {product.marca?.imagem ? (
                    <img
                      src={product.marca.imagem}
                      alt={product.marca.nome}
                      className="w-12 h-12 object-cover rounded mr-4"
                    />
                  ) : (
                    <div className="w-12 h-12 bg-gray-200 flex items-center justify-center rounded mr-4">
                      <span className="text-gray-500 text-sm">Sem imagem</span>
                    </div>
                  )}
                  <span className="text-gray-700">{product.nome}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;